/* ---------------- Polyfills ---------------- */
window.requestAnimationFrame = window.requestAnimationFrame ||
  window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame || function (timeOutFn) { return setTimeout(timeOutFn, 1000 / 60); };

function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      try {
        if (conditionFn()) return resolve();
      } catch (e) {}
      requestAnimationFrame(checkCondition);
    }
    checkCondition();
  });
}

/* ---------------- Main ---------------- */
window["CP_MS_PDP_28_V1"] = function initCpMsPdp28V1() {
  if (!document.body || document.body.classList.contains("CP_MS_PDP_28_V1")) return;
  document.body.classList.add("CP_MS_PDP_28_V1");


  /* ---------- COMPLETE LOOK KURTAS PDP ---------- */
  const completeLookKurtasPdp = document.body.getAttribute("data-complete-look-url");


  /* ---------- Utilities ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  const STATE = {
    observers: [],
    selectedVariantId: null
  };

  function onCleanup(cb){ STATE.observers.push(cb); }
  function cleanup(){
    STATE.observers.forEach(fn => { try{ fn(); }catch(e){} });
    STATE.observers.length = 0;
  }

  /* ---------- Modal: create once ---------- */
  function ensureSizeModal() {
    if (qs(".CP-size-modal")) return;
    const popupHTML = `
      <div class="CP-size-modal" style="display:none;">
        <div class="CP-modal-content" role="dialog" aria-modal="true" aria-label="Choose options">
          <div class="CP-modal-header">
            <h3 class="CP-modal-title">CHOOSE OPTIONS</h3>
            <button class="CP-close-btn" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"></path></svg>
            </button>
          </div>

          <div class="CP-product-size"></div>

          <div class="CP-quantity">
            <label>Quantity:</label>
            <div class="CP-quantity-box">
              <button class="CP-qty-btn minus" aria-label="Decrease quantity">−</button>
              <input type="text" value="1" inputmode="numeric" />
              <button class="CP-qty-btn plus" aria-label="Increase quantity">+</button>
            </div>
          </div>

          <div class="CP-modal-actions">
            <button class="CP-cancel-btn">CANCEL</button>
            <button class="CP-product-atc">ADD</button>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", popupHTML);
  }

  /* ---------- Overlay + Bottom section: create once ---------- */
  function ensureOverlayAndBottomSection() {
    if (!qs(".CP-overlay")) {
      const overlay = document.createElement("div");
      overlay.className = "CP-overlay";
      document.body.appendChild(overlay);
    }
    if (!qs(".CP-bottom-wear-container")) {
      const section = document.createElement("div");
      section.className = "CP-card-container CP-bottom-wear-container";
      section.innerHTML = `
        <div class="CP-card-header">
          <h2 class="CP-card-heading">Complete the Look</h2>
          <span class="CP-close-icon" role="button" tabindex="0" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M5.333 15.833 4.167 14.667 8.833 10 4.167 5.333 5.333 4.167 10 8.833 14.667 4.167 15.833 5.333 11.167 10 15.833 14.667 14.667 15.833 10 11.167 5.333 15.833Z" fill="#852221"/></svg>
          </span>
        </div>
        <div class="CP-scroll-container"></div>
      `;
      document.body.appendChild(section);
    }
  }

  /* ---------- Data helpers ---------- */
  async function fetchProductVariants(slug) {
    const url = window.Shopify.routes.root + `products/${slug}.js`;
    try {
      const res = await fetch(url, { credentials: "same-origin" });
      if (!res.ok) throw new Error("Product fetch failed");
      const product = await res.json();
      return product.variants || [];
    } catch (e) {
      console.error("Error fetching product variants:", e);
      return [];
    }
  }

  function addToCart(variantId, quantity = 1) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity })
    }).then(r => r.json());
  }

//   async function fetchBottomWearHTML() {
//     const url = `https://mysanskritam.com/collections/complete-the-look`;
//     try {
//       const res = await fetch(url, { method: "GET", credentials: "omit" });
//       if (!res.ok) return null;
//       return await res.text();
//     } catch(e) {
//       console.error("Error fetching HTML content:", e);
//       return null;
//     }
//   }

    console.log('COLLECTION - ', `"${completeLookKurtasPdp}" - CHECKED`);
    async function fetchBottomWearHTML() {
        const url = completeLookKurtasPdp;
        try {
            const res = await fetch(url, {
            method: "GET",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            credentials: "same-origin"
            });
            if (!res.ok) {
            console.warn("Collection not found, redirecting...");
            //window.location.href = url;
            return null;
            }
            const html = await res.text();
            return html;
        } catch (error) {
            console.error("Error fetching HTML content:", error);
            return null;
        }
    }


  async function renderBottomSectionProducts() {
    ensureOverlayAndBottomSection();
    const container = qs(".CP-scroll-container");
    if (!container) return;

    // Prevent duplicate population
    if (container.dataset.filled === "true") return;

    const html = await fetchBottomWearHTML();
    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll("ul.productListing li.product");
    if (!products.length) return;

    products.forEach((product) => {
      const title = product.querySelector(".card-link")?.getAttribute("title") || "";
      const imgEl = product.querySelector("img");
      let image = "";
      if (imgEl?.getAttribute("srcset")) {
        image = (imgEl.getAttribute("srcset").split(",")[0] || "").split(" ")[0] || "";
        if (image && !image.startsWith("http")) image = "https:" + image;
      } else if (imgEl?.getAttribute("src")) {
        image = imgEl.getAttribute("src");
        if (image && !image.startsWith("http")) image = "https:" + image;
      }

      const url = product.querySelector(".card-link")?.getAttribute("href") || "#";
      const price = product.querySelector(".price-item--regular")?.innerText?.trim() || "";

      const card = document.createElement("div");
      card.className = "CP-card";
      card.innerHTML = `
        <a href="${url}">
          <img src="${image}" alt="${title}" class="CP-card-image"/>
        </a>
        <p class="CP-card-title">${title}</p>
        <div class="CP-card-bottom">
          <div class="CP-card-price">${price}</div>
          <img src="https://cdn.shopify.com/s/files/1/0496/1003/1256/files/cartIcon.png?v=1750331068" class="CP-cart-icon" alt="Cart Icon"/>
        </div>
      `;
      container.appendChild(card);
    });

    container.dataset.filled = "true";
  }

  /* ---------- Buttons duplication guard ---------- */
  function ensureCustomButtons() {
    const mainBtn = qs(".productView-buttons .product-form__submit");
    if (!mainBtn) return;

    if (!qs(".CP-custom-atc")) {
      const customAtc = document.createElement("button");
      customAtc.type = "button";
      customAtc.className = "CP-custom-atc";
      customAtc.textContent = (mainBtn.textContent || "").trim();
      if (mainBtn.disabled) customAtc.classList.add("CP-disabled");
      mainBtn.closest(".productView-buttons")?.insertAdjacentElement("afterend", customAtc);

      // Mirror state
      const obs = new MutationObserver(() => {
        customAtc.textContent = (mainBtn.textContent || "").trim();
        if (mainBtn.disabled) customAtc.classList.add("CP-disabled");
        else customAtc.classList.remove("CP-disabled");
      });
      obs.observe(mainBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["disabled"] });
      onCleanup(() => obs.disconnect());
    }

    const stickyBtn = qs("sticky-add-to-cart .product-form__submit");
    if (stickyBtn && !qs(".CP-custom-sticky")) {
      const customSticky = document.createElement("button");
      customSticky.type = "button";
      customSticky.className = "CP-custom-sticky";
      customSticky.textContent = (stickyBtn.textContent || "").trim();
      if (stickyBtn.disabled) customSticky.classList.add("CP-disabled");
      stickyBtn.insertAdjacentElement("afterend", customSticky);

      const obs2 = new MutationObserver(() => {
        customSticky.textContent = (stickyBtn.textContent || "").trim();
        if (stickyBtn.disabled) customSticky.classList.add("CP-disabled");
        else customSticky.classList.remove("CP-disabled");
      });
      obs2.observe(stickyBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["disabled"] });
      onCleanup(() => obs2.disconnect());
    }
  }

  /* ---------- Sticky hide/show based on custom ATC visibility ---------- */
  function ensureStickyVisibilitySync() {
    const stickyContainer = qs("sticky-add-to-cart.productView-stickyCart");
    const customAtc = qs(".CP-custom-atc");
    if (!stickyContainer || !customAtc) return;

    // Avoid multiple observers
    if (stickyContainer.dataset.cpObs === "1") return;
    stickyContainer.dataset.cpObs = "1";

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) stickyContainer.classList.add("CP-hide-sticky");
          else stickyContainer.classList.remove("CP-hide-sticky");
        });
      },
      { root: null, threshold: 0.1 }
    );
    io.observe(customAtc);
    onCleanup(() => io.disconnect());
  }

  /* ---------- Open / Close helpers ---------- */
  function openBottomLook() {
    ensureOverlayAndBottomSection();
    qs(".CP-bottom-wear-container")?.classList.add("CP-active");
    qs(".CP-overlay")?.classList.add("CP-active");
  }
  function closeBottomLook() {
    qs(".CP-bottom-wear-container")?.classList.remove("CP-active");
    qs(".CP-overlay")?.classList.remove("CP-active");
  }

  /* ---------- Variant validation helper ---------- */
  function isMainVariantSelected() {
    var hasError = false;
    var firstErrorEl = null;

    // Clear previous error messages
    document.querySelectorAll('.variant-error-message').forEach(function(el) {
      el.style.display = 'none';
      el.textContent = '';
    });

    // Check radio-based variant picker
    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      var fieldsets = variantRadios.querySelectorAll('fieldset.product-form__input');
      fieldsets.forEach(function(fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) {
          hasError = true;
          var optionName = fieldset.querySelector('legend.form__label')
            ? fieldset.querySelector('legend.form__label').childNodes[0].textContent.trim().replace(':', '')
            : 'variant';
          var errorDiv = fieldset.querySelector('.variant-error-message');
          if (errorDiv) {
            errorDiv.textContent = 'Please select a ' + optionName;
            errorDiv.style.display = 'block';
            if (!firstErrorEl) firstErrorEl = errorDiv;
          }
        }
      });
    }

    // Check dropdown-based variant picker
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var selectWrappers = variantSelects.querySelectorAll('.product-form__input--dropdown');
      selectWrappers.forEach(function(wrapper) {
        var select = wrapper.querySelector('select');
        if (select && (select.value === '' || select.value === null)) {
          hasError = true;
          var optionName = wrapper.querySelector('.form__label')
            ? wrapper.querySelector('.form__label').childNodes[0].textContent.trim().replace(':', '')
            : 'variant';
          var errorDiv = wrapper.querySelector('.variant-error-message');
          if (errorDiv) {
            errorDiv.textContent = 'Please select a ' + optionName;
            errorDiv.style.display = 'block';
            if (!firstErrorEl) firstErrorEl = errorDiv;
          }
        }
      });
    }

    if (hasError) {
      if (firstErrorEl) {
        firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
    return true;
  }

  /* ---------- Wire events once ---------- */
  function wireGlobalClicks() {
    if (document.body.dataset.cpClicks === "1") return;
    document.body.dataset.cpClicks = "1";

    document.addEventListener("click", async (e) => {
      const target = e.target;

      // Custom ATC (main / sticky)
      if (target.classList?.contains("CP-custom-atc")) {
        if (!isMainVariantSelected()) return;
        //document.body.classList.add("show-bottomwear");
        openBottomLook();
        return;
      }
      if (target.classList?.contains("CP-custom-sticky")) {
        if (!isMainVariantSelected()) return;
        document.body.classList.remove("show-mobile-options");
        openBottomLook();
        return;
      }

      // Close: header X, overlay background
      if (target.closest?.(".CP-close-icon") || target.classList?.contains("CP-overlay")) {
        //document.body.classList.remove("show-bottomwear");
        closeBottomLook();
        const atcButton = qs(".productView-buttons .product-form__submit");
        atcButton?.click(); // open minicart, if your theme does
        return;
      }

      // Card cart icon → open size modal + load variants
      if (target.classList?.contains("CP-cart-icon")) {
        ensureSizeModal();
        const modal = qs(".CP-size-modal");
        const modalContent = qs(".CP-modal-content", modal);
        const sizeContainer = qs(".CP-product-size", modalContent);
        const atcBtn = qs(".CP-product-atc", modalContent);
        const cancelBtn = qs(".CP-cancel-btn", modalContent);
        const closeBtn = qs(".CP-close-btn", modalContent);
        const qtyInput = qs(".CP-quantity-box input", modalContent);
        const minusBtn = qs(".CP-qty-btn.minus", modalContent);
        const plusBtn = qs(".CP-qty-btn.plus", modalContent);

        // Identify product slug from the card link
        const productItem = target.closest(".CP-card");
        const anchor = productItem?.querySelector('a[href*="/products/"]');
        const href = anchor?.getAttribute("href") || "";
        const slugMatch = href.match(/\/products\/([^/?#]+)/);
        const slug = slugMatch ? slugMatch[1] : null;
        if (!slug) return;

        modal.style.display = "flex";

        // Reset
        STATE.selectedVariantId = null;
        sizeContainer.innerHTML = `<label class="CP-size-label">Size: <span id="CP-selected-size">-</span></label><div class="CP-size-options"></div>`;
        const sizeOptionsWrapper = qs(".CP-size-options", sizeContainer);
        const sizeLabelSpan = qs("#CP-selected-size", sizeContainer);

        let variants = await fetchProductVariants(slug);
        let hasAvailable = false;

        variants.forEach((variant) => {
          const btn = document.createElement("button");
          btn.className = "CP-size-btn";
          btn.textContent = variant.title;
          btn.dataset.variantId = variant.id;
          if (!variant.available) {
            btn.disabled = true;
            btn.classList.add("CP-size-disabled");
          } else {
            if (STATE.selectedVariantId === null) {
              STATE.selectedVariantId = variant.id;
              btn.classList.add("CP-size-selected");
              sizeLabelSpan.textContent = variant.title;
            }
            hasAvailable = true;
          }
          btn.addEventListener("click", () => {
            qsa(".CP-size-btn", sizeOptionsWrapper).forEach(b => b.classList.remove("CP-size-selected"));
            btn.classList.add("CP-size-selected");
            STATE.selectedVariantId = variant.id;
            sizeLabelSpan.textContent = variant.title;
          });
          sizeOptionsWrapper.appendChild(btn);
        });

        if (!hasAvailable) {
          atcBtn.disabled = true;
          atcBtn.classList.add("CP-atc-disabled");
        } else {
          atcBtn.disabled = false;
          atcBtn.classList.remove("CP-atc-disabled");
        }

        // let currentQty = 1;
        // qtyInput.value = currentQty;
        // minusBtn.onclick = () => { if (currentQty > 1) { currentQty--; qtyInput.value = currentQty; } };
        // plusBtn.onclick = () => { currentQty++; qtyInput.value = currentQty; };
        // qtyInput.oninput = () => {
        //   const val = parseInt(qtyInput.value, 10);
        //   if (!isNaN(val) && val > 0) currentQty = val;
        //   else qtyInput.value = currentQty;
        // };

//         const minusBtn = document.querySelector(".qty-minus");
// const plusBtn = document.querySelector(".qty-plus");
// const qtyInput = document.querySelector(".qty-input");

let currentQty = 1;
qtyInput.value = currentQty;

minusBtn.onclick = () => {
  if (currentQty > 1) {
    currentQty--;
  } else {
    currentQty = 1; // reset to min
  }
  qtyInput.value = currentQty;
};

plusBtn.onclick = () => {
  if (currentQty < 5) {
    currentQty++;
  } else {
    currentQty = 5; // reset to max
  }
  qtyInput.value = currentQty;
};

qtyInput.oninput = () => {
  const val = parseInt(qtyInput.value, 10);
  if (!isNaN(val)) {
    if (val < 1) currentQty = 1;
    else if (val > 5) currentQty = 5;
    else currentQty = val;
  } else {
    currentQty = 1;
  }
  qtyInput.value = currentQty;
};

        const closeModal = () => {
          modal.style.display = "none";
          sizeContainer.innerHTML = "";
          STATE.selectedVariantId = null;
          currentQty = 1;
          qtyInput.value = currentQty;
        };
        closeBtn.onclick = cancelBtn.onclick = closeModal;
        modal.addEventListener("click", (evt) => { if (evt.target === modal) closeModal(); }, { once: true });

        atcBtn.onclick = async () => {
          if (!STATE.selectedVariantId) return;
          try {
            await addToCart(STATE.selectedVariantId, currentQty);
            closeModal();
            closeBottomLook();
            const atcButton = qs(".productView-buttons .product-form__submit");
            atcButton?.click(); // open minicart
          } catch (e) {
            console.error("Error adding to cart:", e);
          }
        };

        return;
      }
    });
  }

  /* ---------- Boot ---------- */

  // 1) Ensure core UI that doesn't depend on bottom section
  waitUntil(() => qs(".productView-buttons .product-form__submit"))
    .then(() => {
      ensureCustomButtons();
      ensureSizeModal();
    })
    .then(() => {
      // 2) Render bottom section (async), then wire sticky + open/close handlers
      return renderBottomSectionProducts();
    })
    .then(() => {
      ensureStickyVisibilitySync();
      wireGlobalClicks();
    });

  // In case sticky or main ATC renders late, re-check a few times
  let retry = 0;
  (function lateCheck(){
    if (!qs(".CP-custom-atc") || !qs(".CP-custom-sticky")) {
      ensureCustomButtons();
      ensureStickyVisibilitySync();
    }
    if (retry++ < 20) requestAnimationFrame(lateCheck);
  })();

  // Cleanup on page hide (SPA navigations etc.)
  window.addEventListener("pagehide", cleanup, { once: true });
};

/* Run */
window.CP_MS_PDP_28_V1();